import React, { useEffect } from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import DataSourceDoc from "../../documentation/DataSourceDocumentation";
import TextButtonWithDocumentation from "../../documentation/TextButtonDocumentation";
import { StyledRadio } from "../../../../../utils/designComponents/StyledRadio";
import InfoIconComponent from "./InfoIcon";

const smallFont = { fontSize: 12 };
var prevDataSource = "";
const DataSource = (props) => {
  let top = props.top;
  let dispatchTop = props.dispatchTop;

  //const displayDocs
  useEffect(() => {
    if (top.dataSource === "SIMULATED" || top.dataSource === "REPLAY") {
      dispatchTop({ brokerage: "BACKTEST", accountNumber: "BACKTEST" });
    }
  }, [top.dataSource]);

  return (
    <div>
      <FormControl component="fieldset" variant="outlined">
        <RadioGroup
          row
          aria-label="dataSource"
          name="dataSource"
          value={top.dataSource}
          onChange={(ev) => {
            dispatchTop({ dataSource: ev.target.value });
            if (prevDataSource !== ev.target.value) {
              props.setOptionChoices({});
              props.setOptionChains({});
              prevDataSource = ev.target.value;
            }
          }}
        >
          <Grid container>
            <Grid item xs={6}>
              <FormLabel>
                <Typography style={{ fontSize: 12 }}>
                  {" "}
                  <InfoIconComponent docs={DataSourceDoc} />
                  DataSource:{" "}
                </Typography>
              </FormLabel>
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                value="LIVE"
                control={<StyledRadio />}
                label={<Typography style={smallFont}>Live</Typography>}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                value="SIMULATED"
                control={<StyledRadio />}
                label={<Typography style={smallFont}>Simulated</Typography>}
              />
            </Grid>
          </Grid>
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default DataSource;
